<div class="overlay">
    <div class="chart_container" style="z-index: 10000;">
        <!-- Close button -->
        <div class="row_1">
            <div class="buttons_container">
                @if (selectedFilter=='day') {
                <button mat-raised-button color="primary" [disabled]="chart_Loading"
                    (click)="setFilter('day')">Day</button>
                }@else{
                <button mat-stroked-button color="primary" [disabled]="chart_Loading"
                    (click)="setFilter('day')">Day</button>
                }
                @if (selectedFilter=='week') {
                <button mat-raised-button color="primary" [disabled]="chart_Loading"
                    (click)="setFilter('week')">Week</button>
                }@else{
                <button mat-stroked-button color="primary" [disabled]="chart_Loading"
                    (click)="setFilter('week')">Week</button>
                }
                @if (selectedFilter=='month') {
                <button mat-raised-button color="primary" [disabled]="chart_Loading"
                    (click)="setFilter('month')">Month</button>
                }@else{
                <button mat-stroked-button color="primary" [disabled]="chart_Loading"
                    (click)="setFilter('month')">Month</button>
                }
            </div>
            <div class="">
                <button mat-icon-button mat-dialog-close (click)="closeModal()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Filters -->
        <div class="row_2" *ngIf="!chart_Loading">
            <table class="moving_avg" *ngIf="chart_type=='line'">
                <thead>
                    <tr>
                        <th></th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>1 Day Avg.</th>
                        <td>{{day_1}}</td>
                    </tr>
                    <tr>
                        <th>7 Days Avg.</th>
                        <td>{{days_7}}</td>
                    </tr>
                    <tr>
                        <th>30 Days Avg.</th>
                        <td>{{days_30}}</td>
                    </tr>
                </tbody>
            </table>
            @if (chart_type=='column') {
            <div class="row_2">
                <div class="legendbox" style="margin-top: -10px; margin-right: 30px;">
                    <div style="background-color: #ff2a1b;"></div><strong>ON</strong>
                    <div style="background-color: #72FF13;;"></div><strong>OFF</strong>

                </div>
            </div>
            }
        </div>


        <!-- Loading spinner -->
        <div class="oven_summary_box">
            <ng-container *ngIf="chart_Loading; else chartContent">
                <app-spinner />
            </ng-container>

            <ng-template #chartContent>
                <div id="chartContainer"></div>
            </ng-template>
            <div class="oven_chart_err_message" *ngIf="no_data && !chart_Loading">
                <div class="">NO DATA AVAILABLE</div>
            </div>

            <!-- Chart -->
        </div>
    </div>
</div>